<script context="module"></script>

<script>export let elem;
export let props;
export let data;
const tableSortType = "report";
$:
  exportableProperties = props.properties ? Object.values(props.properties).filter((property) => property.column.export).map((property) => {
    if (property.column.key === "id") {
      setPosition(property, -100);
    } else if (property.column.key === "time") {
      setPosition(property, -99);
    } else if (property.column.key === "geometry.label") {
      setPosition(property, -98);
    } else if (property.column.key === "geometry.lat") {
      setPosition(property, -97);
    } else if (property.column.key === "geometry.lng") {
      setPosition(property, -96);
    } else if (property.column.key.startsWith("callbacks")) {
      setPosition(property, 1e3);
    } else if (property.column.key === "poster.time") {
      setPosition(property, 1001);
    } else if (property.column.key === "poster.channel") {
      setPosition(property, 1002);
    } else if (property.column.key === "poster.id") {
      setPosition(property, 1003);
    } else if (property.column.key === "poster.name") {
      setPosition(property, 1004);
    } else if (property.column.key === "poster.role") {
      setPosition(property, 1005);
    } else if (property.column.key === "type") {
      setPosition(property, 1006);
    } else if (property.column.key === "active") {
      setPosition(property, 1007);
    } else if (property.column.key === "deleted") {
      setPosition(property, 1008);
    } else if (!property.column.position || property.column.position[tableSortType] === void 0) {
      setPosition(property, -1);
    }
    return property;
  }).sort((p0, p1) => {
    const c0Index = p0.column.position ? p0.column.position[tableSortType] : void 0;
    const c1Index = p1.column.position ? p1.column.position[tableSortType] : void 0;
    if (c0Index !== void 0) {
      if (c1Index !== void 0) {
        if (c1Index != c0Index) {
          return c0Index - c1Index;
        } else {
          return p0.column.title.localeCompare(p1.column.title);
        }
      } else {
        return -1;
      }
    } else {
      if (c1Index !== void 0 && c1Index >= 0) {
        return 1;
      } else {
        return p0.column.title.localeCompare(p1.column.title);
      }
    }
  }) : void 0;
const setPosition = (property, position) => {
  const columnPosition = {
    [tableSortType]: position
  };
  if (property.column.position) {
    Object.assign(property.column.position, columnPosition);
  } else {
    property.column.position = columnPosition;
  }
  return property;
};
</script>

<div>
  <table bind:this={elem}>
    {#if exportableProperties && data}
      <thead>
        <tr>
          {#each exportableProperties as property}
            <th>{property.column.title}</th>
          {/each}
        </tr>
      </thead>
      <tbody>
        {#each data.observations as observationDatum (observationDatum.id)}
          <tr>
            {#each exportableProperties as property}
              <td>{@html property.export(observationDatum)}</td>
            {/each}
          </tr>
        {/each}
      </tbody>
    {/if}
  </table>
</div>

<style>
  div {
    overflow-x: clip;
  }
  table {
    border: 0;
    border-collapse: collapse;
    width: 100%;
  }

  .report table thead {
    background-color: var(--header-surface-color);
  }
  table thead tr th {
    font-weight: normal;
    text-align: unset;
  }
  table thead tr th {
    color: var(--header-onSurface-color);
  }
  table thead th {
    padding: 1em;
  }
  table tfoot td {
    padding: 1em;
  }
  table tbody td {
    padding: 0 1em 1em 1em;
  }
  table tbody tr td {
    color: var(--section-onSurface-color);
  }
</style>
